<div class="session-requests-container">
    <!-- Header Section -->
    <header class="page-header">
        <h1>Session Requests</h1>
        <p>Manage incoming session requests from students.</p>
    </header>

    <!-- Requests Card -->
    <div class="requests-card">
        <div class="table-controls">
            <div class="search-box">
                <i class="bi bi-search"></i>
                <input type="text" placeholder="Search by student name or topic..." [(ngModel)]="searchQuery">
            </div>
            <!-- <div class="filter-buttons">
                <button [class.active]="activeFilter === 'All'" (click)="setFilter('All')">All</button>
                <button [class.active]="activeFilter === 'Free'" (click)="setFilter('Free')">Free</button>
                <button [class.active]="activeFilter === 'Paid'" (click)="setFilter('Paid')">Paid</button>
            </div> -->
        </div>

        <div class="table-responsive">
            <table class="table requests-table">
                <thead>
                    <tr>
                        <th>STUDENT</th>
                        <th>DATE</th>
                        <th>TIME</th>
                        <th>DURATION</th>
                        <th>TOPIC</th>
                        <th>CATEGORY</th>
                        <th>STATUS</th>
                        <th class="text-end">ACTIONS</th>
                    </tr>
                </thead>
                <tbody *ngIf="isLoading">
                    <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
                        <td>
                            <div class="student-cell">
                                <div class="avatar-sm skeleton-shimmer"></div>
                                <div class="skeleton-shimmer skeleton-text-name"></div>
                            </div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-text-wide"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-text-wide"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-text-wide"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-text-wide"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-badge-sm"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-badge-sm"></div>
                        </td>
                        <td class="text-end">
                            <div class="action-buttons">
                                <div class="skeleton-shimmer skeleton-btn-inline"></div>
                                <div class="skeleton-shimmer skeleton-btn-inline"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!isLoading">
                    <tr *ngFor="let request of filteredRequests">
                        <td>
                            <div class="student-cell">
                                <div class="avatar-sm" [ngClass]="request.avatarColorClass">
                                    {{ request.initials }}
                                </div>
                                <span class="student-name">{{ request.studentName }}</span>
                            </div>
                        </td>
                        <td data-label="DATE"><span class="date-text">{{ request.date }}</span></td>
                        <td data-label="TIME"><span class="time-text">{{ request.time }}</span></td>
                        <td data-label="DURATION"><span class="duration-pill">{{ request.duration }}</span></td>
                        <td data-label="TOPIC"><span class="topic-text">{{ request.topic }}</span></td>
                        <td data-label="CATEGORY"><span class="category-text">{{ request.category }}</span></td>
                        <td data-label="STATUS">
                            <app-status-badge [status]="request.status"></app-status-badge>
                        </td>
                        <td class="text-end" data-label="ACTIONS">
                            <div class="action-buttons" *ngIf="request.status === SessionStatus.AWAITING_ACCEPTANCE">
                                <button class="btn btn-accept" (click)="acceptRequest(request)" title="Accept Request">
                                    <i class="bi bi-check-circle"></i> Accept
                                </button>
                                <button class="btn btn-reject" (click)="rejectRequest(request)" title="Reject Request">
                                    <i class="bi bi-x-circle"></i> Reject
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- No Results for Search -->
                    <tr *ngIf="requests.length > 0 && filteredRequests.length === 0">
                        <td colspan="8" class="text-center py-5">
                            <div class="no-data">
                                <i class="bi bi-search fs-3 text-muted d-block mb-3"></i>
                                <p class="text-muted fw-medium">No results found for "{{ searchQuery }}"</p>
                                <button class="btn btn-sm btn-outline-secondary mt-2" (click)="searchQuery = ''">Clear
                                    Search</button>
                            </div>
                        </td>
                    </tr>

                    <!-- No Requests at All -->
                    <tr *ngIf="requests.length === 0">
                        <td colspan="8" class="text-center py-5">
                            <div class="no-data">
                                <i class="bi bi-inbox fs-1 text-muted d-block mb-3"></i>
                                <p class="text-muted fw-medium">No session requests available at the moment.</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>